<template>
  <div class="container-fluid p-1 p-lg-5 mt-3">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h6>
              <button class="back-btn" type="button" @click="back()">
                <i class="fas fa-arrow-left"></i>
              </button>
              New Promotion Ticket
            </h6>
          </div>

          <div class="card-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Ticket Name <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-model="promoRequest.ticket_name"
                />
                <small class="text-danger">{{
                  validationData.ticket_name
                }}</small>
              </div>

              <div class="form-group">
                <label>Description <span class="text-danger">*</span></label>
                <vue-editor v-model="promoRequest.decription" />
                <small class="text-danger">{{
                  validationData.decription
                }}</small>
              </div>

              <div class="form-group">
                <label>Type <span class="text-danger">*</span></label>
                <select class="form-control" v-model="promoRequest.type">
                  <option disabled value="">Select Type</option>
                  <option value="Both">Both</option>
                  <option value="Accumulator">Accumulator</option>
                  <option value="Handicap">Handicap</option>
                </select>
                <small class="text-danger">{{ validationData.type }}</small>
              </div>

              <div class="form-group">
                <label>Purpose <span class="text-danger">*</span></label>
                <select class="form-control" v-model="promoRequest.purpose">
                  <option disabled value="">Select Purpose</option>
                  <option value="Referral">Referral</option>
                  <option value="Deposit">Deposit</option>
                  <option value="StarExchange">StarExchange</option>
                  <option value="Manual">Manual</option>
                </select>
                <small class="text-danger">{{ validationData.purpose }}</small>
              </div>

              <div class="form-group">
                <label>Value Type <span class="text-danger">*</span></label>
                <select class="form-control" v-model="promoRequest.value_type">
                  <option disabled value="">Select Value Type</option>
                  <option value="Fix">Fix</option>
                  <option value="Percentage">Percent</option>
                </select>
                <small class="text-danger">{{
                  validationData.value_type
                }}</small>
              </div>

              <div class="form-group">
                <label>Value <span class="text-danger">*</span></label>
                <input
                  type="number"
                  class="form-control"
                  v-model="promoRequest.value"
                />
                <small class="text-danger">{{ validationData.value }}</small>
              </div>

              <div class="form-group">
                <label>Expired At</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="promoRequest.expired_at"
                />
              </div>

              <div class="form-group">
                <label>Expired Days</label>
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  v-model="promoRequest.expired_days"
                />
              </div>

              <div class="form-group">
                <label>Status</label><br />
                <label class="switch">
                  <input type="checkbox" v-model="promoRequest.status" />
                  <span class="slider"></span>
                </label>
                <small class="text-muted">
                  {{ promoRequest.status ? "Active" : "Inactive" }}
                </small>
              </div>

              <small class="text-danger">{{
                validationData.serverError
              }}</small>
              <button type="submit" class="btn btn-primary float-save">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { VueEditor } from "vue2-editor";

export default {
  name: "promotionCreate",
  metaInfo: {
    title: "Promotion",
    titleTemplate: "%s ← New",
  },
  components: {
    Loading,
    VueEditor,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      promoRequest: {
        ticket_name: "",
        decription: "",
        type: "",
        purpose: "",
        value_type: "",
        value: null,
        status: false,
        expired_at: "",
        expired_days: null,
      },
      validationData: {
        ticket_name: "",
        decription: "",
        type: "",
        purpose: "",
        value_type: "",
        value: "",
      },
    };
  },
  methods: {
    ...mapActions({
      promotionStoreAction: "promotionStoreAction",
    }),

    async onSubmit() {
      this.isLoading = true;
      const validation = this.validationRule();
      if (validation === true) {
        this.isLoading = false;
        return;
      }

      // Convert payload into FormData
      const formData = new FormData();
      for (const key in this.promoRequest) {
        if (
          this.promoRequest[key] !== null &&
          this.promoRequest[key] !== undefined
        ) {
          formData.append(key, this.promoRequest[key]);
        }
      }

      // Convert boolean -> number
      formData.set("status", this.promoRequest.status ? "1" : "0");
      

      await this.promotionStoreAction(formData)
        .then((res) => {
          if (res.success === true) {
            this.back();
            this.isLoading = false;
          } else {
            this.isLoading = false;
            this.validationData.serverError = res.message;
            setTimeout(() => (this.validationData.serverError = ""), 3000);
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    validationRule() {
      let flags = [];

      if (!this.promoRequest.ticket_name) {
        this.validationData.ticket_name = "The Ticket Name field is required.";
        flags.push(true);
      } else {
        this.validationData.ticket_name = "";
      }

      if (!this.promoRequest.decription) {
        this.validationData.decription = "Description is required.";
        flags.push(true);
      } else {
        this.validationData.decription = "";
      }

      if (!this.promoRequest.type) {
        this.validationData.type = "Please select promotion type.";
        flags.push(true);
      } else {
        this.validationData.type = "";
      }

      if (!this.promoRequest.purpose) {
        this.validationData.purpose = "Please select promotion purpose.";
        flags.push(true);
      } else {
        this.validationData.purpose = "";
      }

      if (!this.promoRequest.value_type) {
        this.validationData.value_type = "Please select value type.";
        flags.push(true);
      } else {
        this.validationData.value_type = "";
      }

      if (!this.promoRequest.value) {
        this.validationData.value = "Value is required.";
        flags.push(true);
      } else {
        this.validationData.value = "";
      }

      return flags.includes(true);
    },

    back() {
      this.$router.replace({
        path: "promotion-list",
        query: {
          page: 1,
          status: true,
          orderBy: "asc",
          sortKey: "created_at",
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  min-height: 56px;
}
</style>
